import { theme } from '@smooth-ui/core-em'

const spaces = theme.spaces
spaces.xs = 2
spaces.s = 4
spaces.m = 8
spaces.l = 16
spaces.xl = 32
spaces.xxl = 64

export default {
  ...theme,
  ...{
    primary: '#00bcb5',
    success: '#00bcb5',
    fontFamily: '"Rubik","Helvetica Neue",Arial,sans-serif',
    spaces,
  },
}



// WEBPACK FOOTER //
// ./src/UILibrary/theme.js